module.exports = __webpack_public_path__ + "img/add_icon.bb8a8f2e.svg";